import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { BetrBucksSheetDescription } from '@/components/BetrBucksSheetDescription';
import { SizedBox } from '@/components/SizedBox';
import { useAlerts } from '@/feature/alerts/hooks/use-alerts';

type ShowBonusRemovesPromoSheetArgs = {
    message: string;
    confirmLabel: string;
    onConfirm: () => void;
    onKeep?: () => void;
};

/**
 * Confirmation sheet warning that enabling Betr Bucks (bonus) removes the applied promo.
 * Owns the shared layout (image + headline, two stacked buttons, non-dismissible).
 * Callers supply the copy and confirm/keep behavior, which differ between Picks and Sportsbook.
 */
export const useBonusRemovesPromoSheet = () => {
    const { t } = useTranslation('common');
    const { showInfoSheet } = useAlerts();

    return useCallback(
        ({ message, confirmLabel, onConfirm, onKeep }: ShowBonusRemovesPromoSheetArgs) => {
            showInfoSheet({
                description: <BetrBucksSheetDescription message={message} />,
                buttonLabel: confirmLabel,
                secondaryLabel: t('keep_applied_promo'),
                handlePress: onConfirm,
                handleSecondaryPress: onKeep,
                dismissible: false,
                footerContent: <SizedBox value={48} />,
            });
        },
        [showInfoSheet, t]
    );
};
